import { Box, SxProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";

function StickyFooter({
  children,
  sx = {},
}: {
  children: React.ReactNode;
  sx?: SxProps;
}) {
  const theme = useTheme();

  return (
    <>
      <Box
        data-testid="sticky-footer"
        sx={{
          display: "flex",
          position: "sticky",
          bottom: 0,
          marginX: "-1rem",
          marginBottom: "-1.56rem",
          paddingX: "1rem",
          paddingY: theme.tokens.FuelSpacing4,
          backgroundColor: theme.tokens.FuelColorBackgroundWhite,
          zIndex: 0.9,
          justifyContent: "space-between",
          boxShadow: "rgba(0, 0, 0, 0.25) 0px -1px 8px -2px",
          ...sx,
        }}
      >
        {children}
      </Box>
    </>
  );
}

export default StickyFooter;
